import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonContainer,
  ButtonIconContextual,
  ButtonPrimary,
  ContentDisplay,
  HeadingDisplay,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { Term } from '@/modules/trade/services/paid-custody';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideSheetTerm',
  props: {
    data: null,
    showSideSheet: { type: Boolean }
  },
  emits: ['close', 'openPassword'],
  setup(__props: any, { emit }) {

const { data, showSideSheet } = __props as {
  data?: Term;
  showSideSheet: boolean;
};





const closeModal = () => {
  emit('close');
};

const openModalPassword = () => {
  emit('openPassword');
};

const openPDF = () => {
  window.open(data?.cardButton.link, '_blank');
};

return { __sfc: true,emit, closeModal, openModalPassword, openPDF, NebraskaColors, BaseText, ButtonContainer, ButtonIconContextual, ButtonPrimary, ContentDisplay, HeadingDisplay, NavBar, SideSheet }
}

})